import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { CheckIcon, ChevronIcon } from '../../'

export type SelectOption = {
  value: any
  label: string
  prefix?: React.ReactNode
}

type PropTypes = {
  options: SelectOption[]
  defaultValue?: any
  onChange?: (option: SelectOption) => void
}

export default function MinimalSelect ({ options, defaultValue, onChange }: PropTypes) {
  const [selected, setSelected] = useState<SelectOption | undefined>(options.find((option) => option.value === defaultValue))

  return (
    <Listbox
      value={selected}
      defaultValue={defaultValue}
      onChange={(value) => {
        setSelected(value)
        onChange?.(value)
      }}
    >
      {({ open }) => (
        <>
          <div>
            <Listbox.Button className="flex items-center gap-[5px] underline text-sm font-semibold">
              <span>{selected?.label ?? '-'}</span>
              <ChevronIcon
                className="h-[4px] w-[7px] text-gray-800"
              />
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 rounded p-[5px] bg-gray-900 text-base shadow-lg ring-1 ring-gray-900 focus:outline-none sm:text-sm">
                {options.map((option, index) => {
                  const isSelected = option.value === selected?.value
                  return (
                    <Listbox.Option
                      key={index}
                      className={({ active }) =>
                        classNames(
                          active ? 'bg-gray-700' : '',
                          'rounded cursor-default select-none py-1.5 pl-2.5 pr-1 text-white',
                        )
                      }
                      value={option}
                    >
                      {/* Selected was constantly false and I don't know why */}
                      {({ selected: _ }) => (
                        <div className="flex items-center">
                          <span className={classNames(isSelected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                            {option.label}
                          </span>

                          {isSelected
                            ? (
                              <CheckIcon
                                className="h-[12px] w-[12px] ml-2 text-white"
                              />
                            )
                            : null
                          }
                        </div>
                      )}
                    </Listbox.Option>
                  )},
                )}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}
